
const UserIcon = () => {
    return (
        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M13.9652 17.9038C9.45294 17.9038 5.59961 18.586 5.59961 21.3183C5.59961 24.0505 9.4285 24.7571 13.9652 24.7571C18.4774 24.7571 22.3296 24.0738 22.3296 21.3427C22.3296 18.6116 18.5018 17.9038 13.9652 17.9038Z" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
            <path fillRule="evenodd" clipRule="evenodd" d="M13.9655 14.007C16.9266 14.007 19.3266 11.6059 19.3266 8.6448C19.3266 5.68369 16.9266 3.28369 13.9655 3.28369C11.0044 3.28369 8.6033 5.68369 8.6033 8.6448C8.5933 11.5959 10.9777 13.997 13.9277 14.007H13.9655Z" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
        </svg>

    )
}

export default UserIcon